module.exports = __webpack_public_path__ + "media/assets/icons/hand-heart-f25e6e1ad483a3964297ab46a5543a60.svg";